var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M195.876 54.3657C223.57 104.826 205.114 168.182 154.654 195.876C104.195 223.57 40.8383 205.114 13.1444 154.654C-14.5496 104.195 3.90578 40.8384 54.3656 13.1445C104.825 -14.5495 168.182 3.90588 195.876 54.3657ZM21.4835 150.078C46.6498 195.932 104.223 212.703 150.078 187.537C195.932 162.37 212.703 104.797 187.536 58.9425C162.37 13.0883 104.797 -3.68264 58.9424 21.4836C13.0882 46.6499 -3.68273 104.223 21.4835 150.078Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBg);
export default __webpack_public_path__ + "static/media/circle_bg.b89190bc1ca2af287d347515fb0dc4e7.svg";
export { ForwardRef as ReactComponent };